import { MapIcon } from "../interfaces/mapicon";

export function getSpriteIcon(spriteid: number): MapIcon {
    const originx = (spriteid % 5) * 18;
    const originy = Math.floor(spriteid / 5) * 22;
    const icon: MapIcon = {
        url: "/images/pins/mw-pins-sprite.png",
        scaledSize: new google.maps.Size(200, 175),
        origin: new google.maps.Point(originx, originy),
        anchor: new google.maps.Point(9.5, 22),
        size: new google.maps.Size(18, 22)
    };
    return icon;
}

export function getEndIcon(isA: boolean): MapIcon {
    const originx = isA ? 90 : 114;
    const originy = 0;
    const icon: MapIcon = {
        url: "/images/pins/mw-pins-sprite.png",
        scaledSize: new google.maps.Size(200, 175),
        origin: new google.maps.Point(originx, originy),
        anchor: new google.maps.Point(12, 28),
        size: new google.maps.Size(24, 28)
    };
    return icon;
}

export function getMidpointIcon(): MapIcon {
    const icon: MapIcon = {
        url: "/images/pins/mw-pins-sprite.png",
        scaledSize: new google.maps.Size(200, 175),
        origin: new google.maps.Point(138, 0),
        anchor: new google.maps.Point(10.5, 41),
        size: new google.maps.Size(21, 42)
    };
    return icon;
}
